import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-msc-in-computer-science',
  templateUrl: './msc-in-computer-science.component.html',
  styleUrls: ['./msc-in-computer-science.component.scss']
})
export class MscInComputerScienceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
